var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-xs-center pa-4",
      staticStyle: { "max-height": "calc(100vh - 100px)", overflow: "auto" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            transition: "dialog-right-transition",
            persistent: ""
          },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              return _vm.cancelOfficerDialog($event)
            }
          },
          model: {
            value: _vm.openOfficerDialog,
            callback: function($$v) {
              _vm.openOfficerDialog = $$v
            },
            expression: "openOfficerDialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-card", { staticClass: "elc-addmember-card" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "calc(100vh - 50px)",
                      "overflow-y": "auto"
                    }
                  },
                  [
                    _c(
                      "v-container",
                      { attrs: { "grid-list-md": "" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            !_vm.addEditFlag
                              ? _c("h2", { staticClass: "p-10" }, [
                                  _vm._v("Add Officer ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.addEditFlag
                              ? _c("h2", { staticClass: "p-10" }, [
                                  _vm._v("Update Officer ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "0",
                                  right: "0"
                                },
                                attrs: { bottom: "" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    on: { click: _vm.cancelOfficerDialog },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("clear")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Close")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            staticClass: "justify-space-between",
                            attrs: { wrap: "" }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md3: "" }
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.constant.namePrefix,
                                    label: "Prefix "
                                  },
                                  model: {
                                    value: _vm.officer.prefix,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "prefix", $$v)
                                    },
                                    expression: "officer.prefix"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md3: "" }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-capitalize",
                                  attrs: {
                                    rules: _vm.fieldRules,
                                    label: "First Name*",
                                    required: ""
                                  },
                                  on: { keypress: _vm.isAlphaNumeric },
                                  model: {
                                    value: _vm.officer.fname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "fname", $$v)
                                    },
                                    expression: "officer.fname"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md3: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: { label: "Middle Name" },
                                  on: { keypress: _vm.isAlphaNumeric },
                                  model: {
                                    value: _vm.officer.mname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "mname", $$v)
                                    },
                                    expression: "officer.mname"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md3: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    rules: _vm.fieldRules,
                                    label: "Last Name*",
                                    required: ""
                                  },
                                  on: { keypress: _vm.isAlphaNumeric },
                                  model: {
                                    value: _vm.officer.lname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "lname", $$v)
                                    },
                                    expression: "officer.lname"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md3: "" }
                              },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    ref: "menu",
                                    attrs: {
                                      "close-on-content-click": false,
                                      "nudge-right": 40,
                                      lazy: "",
                                      transition: "scale-transition",
                                      "offset-y": "",
                                      "full-width": "",
                                      "max-width": "290px",
                                      "min-width": "290px"
                                    },
                                    model: {
                                      value: _vm.menu,
                                      callback: function($$v) {
                                        _vm.menu = $$v
                                      },
                                      expression: "menu"
                                    }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        slot: "activator",
                                        label: "DOB",
                                        "prepend-icon": "event",
                                        readonly: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.dob = _vm.parseDate(
                                            _vm.officer.dob
                                          )
                                        }
                                      },
                                      slot: "activator",
                                      model: {
                                        value: _vm.officer.dob,
                                        callback: function($$v) {
                                          _vm.$set(_vm.officer, "dob", $$v)
                                        },
                                        expression: "officer.dob"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      ref: "picker",
                                      attrs: {
                                        "no-title": "",
                                        max: "2015-12-31"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.menu = false
                                        }
                                      },
                                      model: {
                                        value: _vm.dob,
                                        callback: function($$v) {
                                          _vm.dob = $$v
                                        },
                                        expression: "dob"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md5: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: { label: "Email", required: "" },
                                  model: {
                                    value: _vm.officer.email,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "email", $$v)
                                    },
                                    expression: "officer.email"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs2: "", md1: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: { label: "+91", disabled: "" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs10: "", md3: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    mask: _vm.mask,
                                    label: "Mobile*",
                                    rules: _vm.fieldRules
                                  },
                                  model: {
                                    value: _vm.officer.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "phone", $$v)
                                    },
                                    expression: "officer.phone"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md4: "" }
                              },
                              [
                                _vm.user.officer_role === 1
                                  ? _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.rolePrefix,
                                        label: "Role*",
                                        "item-text": "value",
                                        "item-value": "id",
                                        readonly: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.getOfficerHierarchy(
                                            _vm.officer.officer_role
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.officer.officer_role,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.officer,
                                            "officer_role",
                                            $$v
                                          )
                                        },
                                        expression: "officer.officer_role"
                                      }
                                    })
                                  : _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.rolePrefix,
                                        label: "Role*",
                                        "item-text": "value",
                                        "item-value": "id"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.getOfficerHierarchy(
                                            _vm.officer.officer_role
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.officer.officer_role,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.officer,
                                            "officer_role",
                                            $$v
                                          )
                                        },
                                        expression: "officer.officer_role"
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md4: "" }
                              },
                              [
                                _vm.user.officer_role === 1
                                  ? _c("v-select", {
                                      ref: "report_to",
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        items: _vm.reportToArr,
                                        label: "Report To*",
                                        "item-text": "name",
                                        rules:
                                          _vm.officer.officer_role !== 5
                                            ? _vm.fieldRules
                                            : "",
                                        disabled: !_vm.reportToFlag,
                                        readonly: "",
                                        "item-value": "officer_id"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "item",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "elc-capital" },
                                                [
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(data.item.name)
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.officer.report_to,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.officer,
                                            "report_to",
                                            $$v
                                          )
                                        },
                                        expression: "officer.report_to"
                                      }
                                    })
                                  : _c("v-select", {
                                      ref: "report_to",
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        items: _vm.reportToArr,
                                        label: "Report To*",
                                        "item-text": "name",
                                        rules:
                                          _vm.officer.officer_role !== 5
                                            ? _vm.fieldRules
                                            : "",
                                        disabled: !_vm.reportToFlag,
                                        "item-value": "officer_id"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "item",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "elc-capital" },
                                                [
                                                  _vm._v(
                                                    "   " +
                                                      _vm._s(data.item.name)
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.officer.report_to,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.officer,
                                            "report_to",
                                            $$v
                                          )
                                        },
                                        expression: "officer.report_to"
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10",
                                attrs: { xs12: "", md4: "" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Election ID",
                                    rules: _vm.elecIdRules,
                                    mask: _vm.maskAlphaNum,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.officer.election_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.officer, "election_id", $$v)
                                    },
                                    expression: "officer.election_id"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.officer.officer_role == 1 ||
                        _vm.user.officer_role == 1 ||
                        _vm.officer.officer_role == null
                          ? _c(
                              "v-layout",
                              { attrs: { wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Pincode*",
                                        mask: "######",
                                        rules: _vm.pinCodeRules,
                                        required: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.getArea(_vm.officer.pincode)
                                        }
                                      },
                                      model: {
                                        value: _vm.officer.pincode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.officer, "pincode", $$v)
                                        },
                                        expression: "officer.pincode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Area" },
                                      model: {
                                        value: _vm.officer.area,
                                        callback: function($$v) {
                                          _vm.$set(_vm.officer, "area", $$v)
                                        },
                                        expression: "officer.area"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.constant.taluka,
                                        label: "Taluka*",
                                        rules: _vm.fieldRules,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.officer.taluka,
                                        callback: function($$v) {
                                          _vm.$set(_vm.officer, "taluka", $$v)
                                        },
                                        expression: "officer.taluka"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "p-10",
                                    attrs: { xs12: "", md3: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "District*",
                                        rules: _vm.nameRules,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.officer.district,
                                        callback: function($$v) {
                                          _vm.$set(_vm.officer, "district", $$v)
                                        },
                                        expression: "officer.district"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm.officer.officer_role != 1
                            ? _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "p-10",
                                      attrs: { xs12: "", md3: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Pincode*",
                                          mask: "######",
                                          rules: _vm.pinCodeRules,
                                          required: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.getArea(_vm.officer.pincode)
                                          }
                                        },
                                        model: {
                                          value: _vm.officer.pincode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.officer,
                                              "pincode",
                                              $$v
                                            )
                                          },
                                          expression: "officer.pincode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "p-10",
                                      attrs: { xs12: "", md3: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "District*",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.officer.district,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.officer,
                                              "district",
                                              $$v
                                            )
                                          },
                                          expression: "officer.district"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "p-10 text-sm-right",
                                attrs: { xs12: "" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "elc-button-radius",
                                    on: { click: _vm.cancelOfficerDialog }
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm._v(" "),
                                !_vm.addEditFlag
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "elc-button-radius-color",
                                        attrs: {
                                          disabled:
                                            _vm.officer.officer_role === 5
                                              ? _vm.officer.fname === "" ||
                                                _vm.officer.lname === "" ||
                                                _vm.officer.officer_role ==
                                                  null ||
                                                _vm.officer.phone == "" ||
                                                _vm.officer.taluka == null
                                              : _vm.officer.fname === "" ||
                                                _vm.officer.lname === "" ||
                                                _vm.officer.officer_role ==
                                                  null ||
                                                _vm.officer.phone == "" ||
                                                !_vm.valid ||
                                                _vm.officer.report_to == null ||
                                                _vm.officer.taluka == null
                                        },
                                        on: { click: _vm.addNewOfficer }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Save\n                                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.addEditFlag
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "elc-button-radius-color",
                                        attrs: { disabled: !_vm.valid },
                                        on: { click: _vm.updateNewOfficer }
                                      },
                                      [
                                        _vm._v(
                                          "Update\n                                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.loader
                          ? _c(
                              "div",
                              { staticClass: "text-xs-center" },
                              [
                                _c("v-progress-circular", {
                                  attrs: {
                                    size: 45,
                                    indeterminate: "",
                                    color: "primary"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
        on: {
          closeAlert: function($event) {
            _vm.alertDialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92d0b9c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92d0b9c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Officer/AddOfficer.vue
// module id = null
// module chunks = 